import { render, staticRenderFns } from "./InventoryProduct.vue?vue&type=template&id=51eb7a41&scoped=true"
import script from "./InventoryProduct.vue?vue&type=script&lang=js"
export * from "./InventoryProduct.vue?vue&type=script&lang=js"
import style0 from "spinkit/scss/spinkit.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./InventoryProduct.vue?vue&type=style&index=1&id=51eb7a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb7a41",
  null
  
)

export default component.exports